import {
  UnitPriceBuyerRange,
  UnitPriceBuyerRangeOption,
  UnitPriceSupplierTier,
  UnitPriceSupplierTierRange,
} from 'domains/skuDomain';
import { FormInstance } from 'antd';

export enum rangeTypeEnum {
  high = 'high',
  low = 'low',
}

export type AutoSplitQuantity = {
  index: number;
  level: rangeTypeEnum;
  value: number;
};

export type Ranges = {
  quantityRanges: any;
  [key: string]: any;
};

export const initRange = (
  highest: number,
  lowest: number,
  isSupplier: boolean
): UnitPriceBuyerRange | UnitPriceSupplierTierRange => {
  if (isSupplier) {
    return {
      highest,
      lowest,
      priceToPaySupplier: 0,
      pricingEnginePrice: null,
      id: Math.random(),
    };
  }
  return {
    highest,
    lowest,
    markup: 0,
    option: UnitPriceBuyerRangeOption.NO_ADDITIONAL,
    priceEach: 0,
    supplierOrgIds: [],
    priceEachFromSupplierPrice: 0,
    markupValue: 0,
  };
};

const autoSplitQuantity = (
  { index, level, value }: AutoSplitQuantity,
  form: FormInstance,
  maxQuantity: number,
  isSupplier: boolean,
  tierHandler: (tierData: UnitPriceSupplierTier[]) => void,
  tierIndex?: number
) => {
  const x = (
    { index, level, value }: AutoSplitQuantity,
    d?: Ranges
  ): Ranges => {
    const formData =
      tierIndex !== undefined
        ? form.getFieldsValue().suppliers?.[tierIndex]
        : form.getFieldsValue();
    const allData = d || formData;
    const { quantityRanges: ranges } = allData;
    const maxQ = maxQuantity;
    const qLen = ranges.length - 1,
      curQ = ranges[index],
      preQ = ranges[index - 1],
      nextQ = ranges[index + 1];
    const isLastLine = qLen === index;
    const insertIndex = index + 1;
    const { low, high } = rangeTypeEnum;
    const isHighLevel = level === high;
    const isLowLevel = level === low;
    if (isHighLevel) {
      curQ.highest = value;
    } else if (isLowLevel) {
      curQ.lowest = value;
    }
    if (isLowLevel) {
      if (index === 0) {
        ranges[0].lowest = 1;
      } else {
        if (curQ.lowest >= curQ.highest) {
          curQ.lowest = curQ.highest - 1;
          x({ index: index - 1, level: high, value: curQ.lowest - 1 }, allData);
        } else {
          if (curQ.lowest <= 1) {
            ranges.splice(0, index);
          } else if (curQ.lowest > preQ.highest) {
            ranges.splice(
              index,
              0,
              initRange(curQ.lowest - 1, preQ.highest + 1, isSupplier)
            );
          } else {
            let highQIndex = 0,
              oldQIndex = index;
            while (oldQIndex > 0) {
              --oldQIndex;
              if (curQ.lowest > ranges[oldQIndex].highest) {
                highQIndex = oldQIndex;
                oldQIndex = 0;
              }
            }
            ranges.splice(highQIndex + 1, index - highQIndex - 1);
            ranges[highQIndex].highest = curQ.lowest - 1;
          }
        }
      }
    } else if (isHighLevel) {
      const setNextRange = () =>
        x({ index: index + 1, level: low, value: curQ.highest + 1 }, allData);
      if (isLastLine) {
        if (curQ.highest >= maxQ) {
          curQ.highest = maxQ;
        } else {
          if (curQ.highest <= curQ.lowest) {
            curQ.highest = maxQ;
          } else {
            ranges.push(initRange(maxQ, curQ.highest + 1, isSupplier));
          }
        }
      } else {
        if (curQ.highest >= maxQ) {
          ranges.splice(insertIndex);
          ranges[ranges.length - 1].highest = maxQ;
        } else {
          if (curQ.highest <= curQ.lowest) {
            curQ.highest = curQ.lowest + 1;
            setNextRange();
          } else {
            if (curQ.highest >= nextQ.lowest) {
              // setNextRange();
              let lowQIndex = index,
                oldQIndex = index;
              while (oldQIndex < qLen) {
                oldQIndex++;
                if (
                  curQ.highest > ranges[oldQIndex].lowest ||
                  curQ.highest === nextQ.highest
                ) {
                  lowQIndex = oldQIndex;
                }
              }
              ranges.splice(index + 1, lowQIndex - index - 1);
              ranges[index + 1].lowest = curQ.highest + 1;
            } else {
              ranges.splice(
                insertIndex,
                0,
                initRange(nextQ.lowest - 1, curQ.highest + 1, isSupplier)
              );
            }
          }
        }
      }
    }
    return allData;
  };

  const newAllData = x({ index, level, value });
  if (tierIndex !== undefined) {
    const data = form.getFieldsValue().suppliers;
    data.splice(tierIndex, 1, newAllData);
    // tierHandler([]);
    form.setFieldsValue({ suppliers: data });
    return;
  }
  form.setFieldsValue(newAllData);
};

const useAutoSplitQuantity = () => {
  return autoSplitQuantity;
};

export default useAutoSplitQuantity;
